module.exports = __webpack_public_path__ + "img/82a9b00c92425b185515057dea3bc3b7.png";